module.exports = __webpack_public_path__ + "static/media/top-slide-1.270ad88e.webp";